import FColumnCellMDP from '../FColumnCellMDP';
export default class FInfoCreditorWarningMDP implements FColumnCellMDP {
    
    componentName: string = "FInfoCreditorWarning";
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                
            }
        }
    }

}